<div class="lesson-wrap" [ngStyle]="{'--lesson-border-color': color, '--lesson-bg': secondaryColor }">
  <div class="time-range">
    <div class="start-time">{{convertDecimalToTimeString(lesson.timeStart)}}</div>
    <div *ngIf="lesson.timeEnd != lesson.timeStart" class="end-time">{{convertDecimalToTimeString(lesson.timeEnd)}}</div>
  </div>
  <div class="main-info">
    <div class="name-wrap">
      <app-text-with-tooltip app-dropdown-trigger class="name" [text]="lesson.name" [link]="'#'" (click)="openDetails($event)" />

      <a *ngIf="lesson.notifications && lesson.notifications.length" class="notification-link" (click)="openNotifications($event)">
        <mat-icon [svgIcon]="'bell-point'" class="notification-icon"></mat-icon>
      </a>
    </div>

    <div class="additional-info">
      <div class="ellipsis-text info-item info-item-type">{{ lesson.type }}</div>

      <ng-container *ngIf="!lesson.canceled">
        <div *ngIf="lesson.submitTo" class="ellipsis-text info-item">
          <mat-icon [svgIcon]="'clock'" class="square-icon info-item-icon"></mat-icon>
          להגשה עד {{ lesson.submitTo | date: 'd/MM' }} ,בשעה {{ lesson.submitTo | date: 'h:mm' }}
        </div>

        <div *ngIf="lesson.location && !lesson.online && !lesson.submitTo" class="ellipsis-text info-item">
          <mat-icon [svgIcon]="'location'" class="square-icon info-item-icon"></mat-icon>
          <span>{{ lesson.location }}</span>
        </div>

        <div *ngIf="lesson.online" class="ellipsis-text info-item">
          <mat-icon [svgIcon]="'video'" class="square-icon info-item-icon"></mat-icon>
          {{onlineClassText}}
        </div>
      </ng-container>

      <span *ngIf="lesson.canceled" class="badge primary-dark-blue">{{cancelledClassText}}</span>
    </div>
  </div>
</div>

<app-lesson-notifications *ngIf="openedNotifications" [notifications]="lesson.notifications" [headerText]="notificationsHeaderText" (close)="closeNotifications()" />

<app-lesson-details
  *ngIf="openedDetails"
  [event]="lesson"
  [color]="color"
  [nooficationText]="notificationsHeaderText"
  [nooficationCount]="(lesson.notifications && lesson.notifications.length ? lesson.notifications.length : 0)"
  (close)="closeDetails()"
  (openNotification)="openNotifications()"
/>
